<template>
  <!-- TODO: Replace headerButtons with a button bar component that takes md-buttons as a child (maybe in the future when md-components is a considered project?) -->
  <md-report-layout :header-buttons="headerButtons"
                    :loading="loading"
                    :loading-text="loadingText"
                    ref="reportLayout">

    <template v-slot:header-left>
      <!-- <md-date-select :init-start="rangeStart" :init-end="rangeEnd" @change="dateRangeChanged" display-mode="header"/> -->
    </template>

    <template v-slot:employee-list>
      <!--md-date-select :init-start="rangeStart" :init-end="rangeEnd" @change="dateRangeChanged"/-->

      <EmployeeList :loading="loadingEmployees"
                        :employees="employees"
                        :can-select-multiple="true"
                        :init-all-selected="true"
                        @employeeSelected="onEmployeeSelected"
                        style="height: calc(100vh - 400px); margin-bottom: 10px;"/>

      <!-- <div class="header" style="font-size: 13px; padding-left: 5px; font-weight:bold; margin-bottom: 10px; text-align: left">
        {{ $t('report.comp.employeesSelected', [countSelectedEmployees, countEmployees]) }}
      </div>

      <div class="header" style="display:flex; flex-direction: row; justify-content: flex-start;">
        <b-button size="sm"
                  variant="outline-secondary"
                  v-on:click="selectAllEmployees"
                  style="border-radius: 0; margin-right: 0.5rem;">
          alle auswählen
        </b-button>
        <b-button size="sm"
                  variant="outline-secondary"
                  v-on:click="deselectAllEmployees"
                  style="border-radius: 0; margin-right: 1rem; justify-self: flex-start;">
          {{ $t('report.comp.deselectAll') }}
        </b-button>

        <b-button size="sm"
                  variant="outline-secondary"
                  v-on:click="toggleShowOnlyActiveEmployees"
                  style="border-radius: 0; margin-left: auto;">
          {{ showOnlyActiveEmployees ? 'alle Mitarbeiter anzeigen' : 'nur aktive Mitarbeiter anzeigen' }}
        </b-button>
      </div> -->
    </template>

    <template v-slot:report-settings>
      <ReportConfig :options="reportConfigData" @configChanged="onReportConfigChange"/>
    </template>

    <template v-slot:report-list>
      <ml-report-list :reports="reports"
                      :loading="loadingReports"
                      @deleteReport="openDeleteReportPopup"
                      @downloadReport="downloadReport"
                      @reportClicked="openReport"/>
    </template>

    <template v-slot:button-bar v-if="creatingReport || !canCreateReport">
      <span v-if="creatingReport">
        <i class="fas fa-circle-notch fa-spin"></i>
         {{ $t('report.comp.reportBeingCreated') }}
      </span>
      <span v-else-if="!storeSelected">
        {{ $t('report.comp.selectAtLeastOneStore') }}
      </span>
      <span v-else-if="customRangeUsed">
        {{ $t('report.comp.dynamicRangesNotSupported') }}
      </span>
      <span v-else>
        {{ $t('report.comp.selectAtLeastOneEmployee') }}
      </span>
    </template>

  </md-report-layout>
</template>

<script>
import moment from 'moment';
import MdReportLayout from '@/components/reportcontext/ReportLayout';
// import MdDateSelect from '@/components/uicomponents/md-date-select';
import MlReportList from '@/components/uicomponents/ml-report-list';
import ReportConfig from '@/components/uicomponents/reportconfig';
import EmployeeList from '@/components/uicomponents/employeelist';
import { reportMixin } from '@/components/reportcontext/report-mixin';
import { mapGetters } from "vuex";
import VueEventBus from '../../vue-event-bus';

export default {
  name: 'reportEmployeeOverview',
  components: {
    MdReportLayout,
    // MdDateSelect,
    MlReportList,
    ReportConfig,
    EmployeeList
  },
  mixins: [ reportMixin ],
  data() {
    return {
      reportType: 'EMPLOYEEOVERVIEW',
      loadingText: this.$t('report.comp.loadingEmployeeOverview'),

      // models: [],
      // individualWageTypes: [],
      mdWageTypes: [],
      contracts: [],
    }
  },
  created: function () {
    // console.log("CREATED");
    VueEventBus.$on("JobReportEvent:jobCreated", this.jobCreated);
    VueEventBus.$on("JobReportEvent:jobStarted", this.jobStarted);
    VueEventBus.$on("JobReportEvent:jobEnded", this.jobEnded);
    VueEventBus.$on("JobReportEvent:jobFailed", this.jobFailed);
  },
  beforeDestroy: function () {
    // console.log("BEFORE DESTROY");
    VueEventBus.$off("JobReportEvent:jobCreated", this.jobCreated);
    VueEventBus.$off("JobReportEvent:jobStarted", this.jobStarted);
    VueEventBus.$off("JobReportEvent:jobEnded", this.jobEnded);
    VueEventBus.$off("JobReportEvent:jobFailed", this.jobFailed);
  },
  destroyed: function () {
    // console.log("DESTROYED");
  },
  mounted() {
    if (this.$store.state.jwt !== undefined && this.$store.state.companyId !== undefined) {

      this.refresh();
    }
  },
  computed: {
    ...mapGetters(['companyId','companySettings', 'storesSettings','employeeContractMap']),
    headerButtons() {
      let helperLinks = [];
      let buttons = [
        {
          classes: 'add-employeetype',
          type: 'block gray',
          disabled: false,
          icon: 'fa-th-list',
          click: ($event) => {
          },
          show: true,

            tooltip: this.$t('report.comp.costCenterQuantityReport'),
            title: this.$t('report.comp.costCenterQuantityReport'),
            helperText: this.$t('report.comp.costCenterQuantityReportDescription'),
          //externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/kb/view/1134428161"
        },
        {
          type: 'block green',
          disabled: this.creatingReport || !this.canCreateReport,
          icon: this.creatingReport ? 'fa-redo' : 'fa-file-check',
          click: ($event) => {
            this.createReportProxy();
          },
          show: true,
          tooltip: this.$t('report.comp.createReport'),
          title: this.$t('report.comp.createReport'),
        },
      ];
      let state = {
        buttons: buttons,
        helperLinks: helperLinks,
        showListIconAlways: true,
      };

      state.helperLinks = [
  {
    icon: "fa-video",
    title: this.$t('report.comp.watchTrainingVideo'),
    helperText: this.$t('report.comp.watchTrainingVideoHelper'),
    externalUrl: "https://www.youtube.com/watch_popup?v=BePh4xNJvsY",
    externalLabel: this.$t('report.comp.trainingVideoReports'),
    cancelLabel: this.$t('global.ui.close')
  },
  {
    title: this.$t('report.comp.getSupport'),
    helperText: this.$t('report.comp.getSupportHelper'),
    externalUrl: 'https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/group/2/create/15',
    externalLabel: this.$t('export.comp.contactSupport'),
    cancelLabel: this.$t('global.ui.close')
  }
];
      return state;
    },

    canCreateReport() {
      return this.storeSelected && this.employeesSelected && !this.customRangeUsed;
    },
    // employmentModelsSelected() {
    //   const employmentModels = this.reportConfig.employmentModels || {};
    //   return (employmentModels.selectedModels || []).length > 0;
    // },
    // wageTypesSelected() {
    //   const individualWageTypes = this.reportConfig.individualWageTypes || {};
    //   return (individualWageTypes.selectedWageTypes || []).length > 0;
    // },
    storeSelected() {
      const storeIds = this.reportConfig.storeIds || {};
      return (storeIds.selectedStores || []).length > 0;
    },
    employeesSelected() {
      return this.countSelectedEmployees > 0;
    },
    customRangeUsed() {
      return this.rangeMode === 'customRange';
    },
  },
  watch: {
    companyId(newVal, oldVal) {
      console.log("COMPANY ID CHANGED", newVal, oldVal);
      this.refresh(true);
    },
    rangeStart() {
      this.updateReportConfig('reportname', this.getReportName());
    },
  },
  // methods that implement data (BUSINESS) logic. (https://en.wikipedia.org/wiki/Business_logic)
  methods: {
    getReportName() {
      let companyName = this.companySettings && this.companySettings.data && this.companySettings.data[0] ? this.companySettings.data[0].name : this.$t('report.comp.company');
        return this.$t('report.comp.employeeOverviewWithCompany', {company: companyName});
    },

    async refresh(force = false) {
      this.loading = true;
      this.updateReportConfig('reportname', this.getReportName());

      try {
        await Promise.all([
          this.$helpers.GetCompanySettings(force),
          this.$helpers.GetStoresSettings(force),
          this.$helpers.GetExportSettingsMap(force),
          this.$helpers.GetEmployeeContractMap(force),
          this.getEmployeeContracts(),
          this.loadReports(this.reportType),
          this.loadEmployees(true),
        ]);
      } catch (error) {
        console.error(error);
      } finally {
        this.generateReportConfigOpts();

        // console.log(this.getReportConfigValue('reportname'));
        // reportConfig can be loaded after generating the options, as reportConfig does not overwrite the options
        this.reportConfig = this.loadReportConfig();
        this.updateReportConfig('reportname', this.getReportName());

        // console.log(this.reports);

        this.loading = false;
      }
    },

    generateReportConfigOpts() {
      let view = this;
      let disabled = !this.CheckEnableConfigEdit
      let specialDisabled = !this.CheckEnableConfigSpecialEdit
      const nameSection = this.createReportConfigSection(this.$t('report.comp.documentName'), true, disabled, 'nameSection');
      this.addTextConfigOption(nameSection, 'reportname', this.$t('report.comp.enterDocumentName'), this.getReportName(), true);

      const commentSection = this.createReportConfigSection(this.$t('employee.contract.comment'), false, disabled, 'commentSection');
      this.addTextConfigOption(commentSection, 'reportcomment', this.$t('report.comp.enterComment'));

      const formatSection = this.createReportConfigSection(this.$t('report.comp.fileFormat'), false, disabled, 'formatSection');
      this.addSelectConfigOption(formatSection, 'fileformat', [
        this.addSelectableValue('PDF', 'pdf', true),
        this.addSelectableValue('CSV', 'csv'),
      ]);


      const storeSection = this.createReportConfigSection('Store', false, disabled, 'storeSection');
      view.addSelectConfigOption(storeSection, 'storeIds', [
        view.addSelectableValue(this.$t('report.comp.allStores'),
          this.storesSettings.data.map(store => view.addSelectableValue(store.name, store.id)),
          this.storesSettings.data.map(store => store.id),
          'selectedStores')
      ], true);

      const contentSection = this.createReportConfigSection(this.$t('report.comp.documentContent'), false, disabled, 'contentSection');
      view.addSelectConfigOption(contentSection, 'content', [
          view.addSelectableValue(this.$t('report.comp.allEmployees'), 1),
          view.addSelectableValue(this.$t('report.comp.nonHiddenEmployees'), 2, true),
          view.addSelectableValue(this.$t('report.comp.activeEmployees'), 3)
      ]);
      view.addSelectConfigOption(contentSection, 'printCostCenterData', [
          view.addSelectableValue(this.$t('report.comp.printCostCenterData'), true, true),
          view.addSelectableValue(this.$t('report.comp.doNotPrintCostCenterData'), false),
      ]);
      view.addSelectConfigOption(contentSection, 'printOvertimeAllowance', [
          view.addSelectableValue(this.$t('report.comp.printOvertimeAllowance'), true, true),
          view.addSelectableValue(this.$t('report.comp.doNotPrintOvertimeAllowance'), false),
      ]);

      const sortingSection = this.createReportConfigSection(this.$t('report.comp.sorting'), false, disabled, 'sortingSection');
      this.addSelectConfigOption(sortingSection, 'sortingParameter', [
          this.addSelectableValue(this.$t('report.comp.sortByEmployeeName'), 'name', true),
          this.addSelectableValue(this.$t('report.comp.sortByPersonnelNumber'), 'personnelNumber', true),
          this.addSelectableValue(this.$t('report.comp.sortByStore'), 'store'),
          this.addSelectableValue(this.$t('report.comp.sortByCostCenter'), 'costCenter')
      ]);

      const localeSection = this.createReportConfigSection(this.$t('report.comp.locale'), false, disabled, 'localeSection');
      this.addLanguageSelectConfigOption(localeSection, 'settingLocale', disabled);

      const headerFormatSection = this.createReportConfigSection(  this.$t('report.comp.header'), false, specialDisabled, 'headerFormatSection');
      this.addSelectConfigOption(headerFormatSection, 'settingDateFormat', [
        this.addSelectableValue('DD.MM.YYYY', 'DD.MM.YYYY', true),
        this.addSelectableValue('YYYY-MM-DD', 'YYYY-MM-DD'),
      ]);

    },

    async createReportProxy() {
      if (this.rangeMode === 'customRange') {

        if (this.rangeStart.month() != this.rangeEnd.month() || this.rangeStart.year() != this.rangeEnd.year()) {
          this.$helpers.error(this.$t('employee.data.error'), this.$t('report.comp.startEndSameMonth'));
          return;
        }
        if (this.rangeStart > this.rangeEnd) {
          this.$helpers.error(this.$t('employee.data.error'), this.$t('report.comp.startBeforeEnd'));
          return;
        }

      }
      await this.generateReport();
    },


    getEmployeeContracts: function () {
      let view = this;
      let url = '/api/sec/proxy/md/employee/contracts';

      url = this.$helpers.appendParam("companyId", this.$store.state.companyId, url, '/api/sec/proxy/md/employee/contracts');

      return this.axios({
        method: 'get',
        headers: {
          'AUTHORIZATION': "Bearer " + this.$store.state.jwt
        },
        url: url
      }).then(resp => {
        return view.$helpers.GetStores()
          .then(storeResponse => {
            let storeIds = storeResponse.map(s => s.id);
            view.contracts = {};
            Object.values(resp.data).forEach(contract => {
              if (storeIds.includes(contract.storeId)) {
                if (view.contracts.hasOwnProperty(contract.remoteId)) {
                  view.contracts[contract.remoteId].push(contract);
                } else {
                  view.contracts[contract.remoteId] = [];
                  view.contracts[contract.remoteId].push(contract);
                }
              }
            });
            // console.log(view.contracts);
          });
      }).catch(error => {
        console.log(error);
      });
    },


    async generateReport() {
      this.creatingReport = true;

      const employeeIds = this.selectedEmployeeIds;

      const dateFormats = {
        'DD.MM.YYYY': 'dmY',
        'YYYY-MM-DD': 'Ymd',
      };
      const dateFormat = dateFormats[this.reportConfig.settingDateFormat] || 'dmY';

      const hourFormats = {
        '3': '3',
        '2': '2',
        'Hm': 'Hm',
      };
      const hourFormat = hourFormats[this.reportConfig.settingHourFormat] || 'Hm';

      let locale = this.reportConfig.settingLocale || 'de';
      if (locale === 'current') {
        locale = this.$i18n.locale;
      }

      const name = this.reportConfig.reportname;
      const comment = this.reportConfig.reportcomment;
      const config = {
        'headerDateFormat': dateFormat,
        'hourFormat': hourFormat,
        'storeIds': this.reportConfig.storeIds.selectedStores,
        'sortingParameter': this.reportConfig.sortingParameter,
        'content': this.reportConfig.content,
        'printCostCenterData': this.reportConfig.printCostCenterData ?? true,
        'printOvertimeAllowance': this.reportConfig.printOvertimeAllowance ?? true,
        'documentComment': comment ?? "",
        'headerLogo': 'ml',
        'fileformat': this.reportConfig.fileformat ?? 'pdf',
        'language': locale,
      };

      // console.log(employeeIds);
      // console.log(config);

      await this.createReport(this.reportType, name, comment ? comment : "", config);

    },
    jobCreated: function () {
      let view = this;
      setTimeout(function () {
        console.log("JOB CREATED EVENT GOT TRIGGERED");
        view.reloadDocuments();
      }, 50);
    },
    jobStarted: function () {
      let view = this;
      setTimeout(function () {
        console.log("JOB STARTED EVENT GOT TRIGGERED");
        view.reloadDocuments();
      }, 100);
    },
    jobEnded: function () {
      let view = this;
      setTimeout(function () {
        console.log("JOB ENDED EVENT GOT TRIGGERED");
        view.reloadDocuments();
      }, 200);
    },
    jobFailed: function () {
      let view = this;
      setTimeout(function () {
        console.log("JOB FAILED EVENT GOT TRIGGERED");
        view.reloadDocuments();
      }, 200);
    },
    reloadDocuments: function () {
      this.loadReports(this.reportType);
    },

    onEmployeeSelected(employee) {
      console.log(employee);
      employee.isSelected = true;
      this.$helpers.info(this.$t('report.comp.attention'), this.$t('report.comp.cannotDeselectEmployees'));
      // this.selectedEmployee = employee.isSelected ? employee : null;
      // No need to update employeeList as the currently selected employee is stored in its own variable
      // this.employeeList = this.employeeList.map(emp => ({ ...emp, selected: emp.id === employee.id }));
    },

  },
}
</script>

<style scoped>
/* remove max-height from sub component: 100vh would cut off long lists */
>>>.config-entry>.body.entry-expanded {
  max-height: 100% !important;
}
</style>
